<app-navbar-style-two></app-navbar-style-two>

<!-- Banner Section -->
<div class="inner-banner" *ngIf="blog">
    <div class="container">
        <div class="inner-title text-center">
            <h3>{{ blog.title }}</h3>
            <ul class="inner-list">
                <li><i class='bx bx-user'></i> {{ blog.author }}</li>
                <li><i class='bx bx-calendar'></i> {{ blog.date | date:'longDate' }}</li>
            </ul>
        </div>
    </div>
    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots-2"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<!-- Loading/Error States -->
<div *ngIf="loading" class="text-center py-5">
    <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
    <p class="mt-3">Loading blog post...</p>
</div>
<div *ngIf="error" class="alert alert-danger text-center my-5">
    <i class="fas fa-exclamation-circle me-2"></i>
    Blog post not found or failed to load.
</div>

<!-- Blog Details -->
<div class="blog-details-area pb-70" *ngIf="blog && !loading && !error">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-article">
                    <div class="blog-article-img mb-4">
                        <img [src]="blog.image" [alt]="blog.title">
                    </div>
                    <div class="article-content">
                        <div [innerHTML]="blog.content"></div>
                    </div>
                    <div class="blog-article-share mt-4">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-sm-6 col-md-7">
                                <div class="blog-tag">
                                    <ul>
                                        <li>Tags:</li>
                                        <li *ngFor="let tag of blog.tags"><a href="javascript:void(0)">#{{ tag }}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-5 col-sm-6 col-md-5">
                                <ul class="social-icon">
                                    <li><a target="_blank" href="#"><i class="bx bxl-facebook"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-twitter"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-instagram"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-linkedin"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="blog-widget-left">
                    <div class="blog-widget ">
                        <h3 class="title">Search</h3>

                        <div class="search-widget">
                            <form class="search-form">
                                <input type="search" class="form-control" placeholder="Search...">
                                <button type="submit"><i class="bx bx-search"></i></button>
                            </form>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Recent Posts</h3>

                        <div class="widget-popular-post">
                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg1" role="img"></span></a>
                                <div class="info">
                                    <span>Jnauary 12, 2023</span> 
                                    <h4 class="title-text"><a routerLink="/blog-details">A Guide to Google SEO</a></h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>

                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg2" role="img"></span></a>
                                <div class="info">
                                    <span>June 30, 2023</span>
                                    <h4 class="title-text"><a routerLink="/blog-details">15 SEO Best Practices</a></h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>

                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg3" role="img"></span></a>
                                <div class="info">
                                    <span>April 09, 2023</span>
                                    <h4 class="title-text"><a routerLink="/blog-details">Website Architecture</a> </h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Categories</h3>

                        <div class="widget_categories">
                            <ul>
                                <li><a routerLink="/blog">Design <span>(1)</span></a></li>
                                <li><a routerLink="/blog">Lifestyle <span>(4)</span></a></li>
                                <li><a routerLink="/blog">Camping <span>(3)</span></a></li>
                                <li><a routerLink="/blog">Support <span>(2)</span></a></li>
                                <li><a routerLink="/blog">Device <span>(6)</span></a></li>
                                <li><a routerLink="/blog">Internet <span>(18)</span></a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Tags</h3>

                        <ul class="blog-widget-tag">
                            <li><a routerLink="/blog">#SEO</a></li>
                            <li><a routerLink="/blog">#Internet</a></li>
                            <li><a routerLink="/blog">#Web</a></li>
                            <li><a routerLink="/blog">#Sass</a></li>
                            <li><a routerLink="/blog">#It & Support</a></li>
                            <li><a routerLink="/blog">#Tik</a></li>
                            <li><a routerLink="/blog">#Tips</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>